import type { TFunction } from 'i18next'

import { formatDate } from '~/helpers/date'
import {
  ROAS_ATTRIBUTION_MARKER_TYPE,
  ROAS_CUTOFF_DATE
} from '~/modules/retailMedia/constants'

type BuildRoasAttributionChartMarkerProps = {
  data?: ReportHistoryCampaigns | null
  compareData?: ReportHistoryCampaigns | null
  isCompare?: boolean
  t: TFunction
}

const getRoasAttributionMarker = ({
  data,
  compareData,
  isCompare = false
}: Omit<BuildRoasAttributionChartMarkerProps, 't'>) => {
  if (data?.marker?.type === ROAS_ATTRIBUTION_MARKER_TYPE) {
    return data.marker
  }

  if (isCompare && compareData?.marker?.type === ROAS_ATTRIBUTION_MARKER_TYPE) {
    return compareData.marker
  }

  return null
}

export const buildRoasAttributionChartMarker = ({
  data,
  compareData,
  isCompare = false,
  t
}: BuildRoasAttributionChartMarkerProps): ChartMarker | null => {
  const marker = getRoasAttributionMarker({ data, compareData, isCompare })

  if (!marker) return null

  const cutoffDateFormatted = formatDate(
    ROAS_CUTOFF_DATE,
    'DD/MM/YYYY',
    t('c:patterns.date')
  )

  return {
    label: marker.label,
    lineColor: '#d99a2b',
    tooltipTitle: t('rm:chart.temporalMarker.title', {
      date: cutoffDateFormatted
    }),
    tooltipBody: t('rm:chart.temporalMarker.body')
  }
}
